module.exports = __webpack_public_path__ + "static/media/spin-button.e95d7d6e.png";